import { render, staticRenderFns } from "./ktzCoupon.vue?vue&type=template&id=1ec19fcb&scoped=true&"
import script from "./ktzCoupon.vue?vue&type=script&lang=js&"
export * from "./ktzCoupon.vue?vue&type=script&lang=js&"
import style0 from "./ktzCoupon.vue?vue&type=style&index=0&id=1ec19fcb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec19fcb",
  null
  
)

export default component.exports